









































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { FilledButton } from '@/components/molecules';
import { TextField } from '@/components/atoms';
import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import TypeBox from '@/components/TypeBox/TypeBox.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import ResumeCard from '@/componentsV2/molecules/ResumeCard/ResumeCard.vue';
import AdminTabs from '@/componentsV2/molecules/AdminTabs/AdminTabs.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import eventBus from '@/utils/eventBus';
import { toNumber, treatValue } from '@/utils/moneyTreatments';

import ImageUploadService from '@/api/ImageUploadService';

import CoinStoreSellingCoinsHistory from './CoinStoreSellingCoinsHistory.vue';
import CoinStoreTransferHistory from './CoinStoreTransferHistory.vue';

type TabMapperType = 'selling-coins-history' | 'transfer-history';

@Component({
  components: {
    TextField,
    SideModalHeader,
    TypeBox,
    Checkbox,
    ResumeCard,
    AdminTabs,
    CoinStoreSellingCoinsHistory,
    CoinStoreTransferHistory,
    FilledButton,
    Typography,
    GhostButton
  }
})
export default class CoinStoreDetail extends Vue {
  @Prop({ required: true }) data: any;

  activeTabKey: TabMapperType = 'selling-coins-history';
  businessData: any = {};
  fileToUpload: any;
  imageUploadService = new ImageUploadService();

  treatValue = treatValue;

  get tabMapper(): Record<TabMapperType, any> {
    return {
      'selling-coins-history': {
        label: 'Selling Coins',
        component: 'CoinStoreSellingCoinsHistory',
        componentProps: {
          businessId: this.data.id
        }
      },
      'transfer-history': {
        label: 'Transfer History',
        component: 'CoinStoreTransferHistory',
        componentProps: {
          businessId: this.data.id
        }
      }
    };
  }

  get tabs() {
    return Object.entries(this.tabMapper).map(([key, value]) => ({
      key,
      label: value.label
    }));
  }

  get getPicture() {
    try {
      if (!this.businessData.picture.includes('https')) return '';
      return {
        background: `url('${this.businessData.picture}')`,
        backgroundSize: 'cover'
      };
    } catch (e) {
      return 'hasNoImage';
    }
  }

  get getDealImage() {
    try {
      if (!this.businessData.dealImage.includes('https')) return '';
      return {
        backgroundImage: `url('${this.businessData.dealImage}')`,
        backgroundSize: 'contain'
      };
    } catch (e) {
      return 'hasNoImage';
    }
  }

  getNumber(str: string) {
    return toNumber(str);
  }

  openManageDealsModal() {
    const modalConfig = {
      isOpen: true,
      component: 'adminCoinStoreDetails',
      data: { ...this.businessData, close: this.closeSendCoinsModal },
      width: '750px',
      subModal: {
        isOpen: true,
        component: 'adminCoinStoreDealsManager'
      }
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  openReturnWalletModal() {
    const modalConfig = {
      isOpen: true,
      component: 'adminCoinStoreDetails',
      data: { ...this.businessData, close: this.closeSendCoinsModal },
      width: '750px',
      subModal: {
        isOpen: true,
        component: 'adminCoinStoreReturnWallet'
      }
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  async handleFileUpload(event: any) {
    this.fileToUpload = event.target.files[0];
    const formData = new FormData();
    if (!this.fileToUpload) {
      this.$notification('File not selected');
      return;
    }
    formData.append('dealImage', this.fileToUpload);
    await this.imageUploadService
      .uploadDealImage(this.businessData.id, formData)
      .then(res => {
        this.businessData.dealImage = res.data.publicPath.large;
      });
  }

  handleDealImageUpload(event: any) {
    event.preventDefault();
    if (
      this.$refs.fileInput &&
      (this.$refs.fileInput as HTMLInputElement).click
    )
      (this.$refs.fileInput as HTMLInputElement).click();
  }

  closeSendCoinsModal() {
    const modalConfig = {
      isOpen: true,
      component: 'adminCoinStoreDetails',
      data: this.businessData,
      width: '750px'
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  handleTabChanges(tabKey: TabMapperType) {
    this.activeTabKey = tabKey;
  }

  updateBusinessDetail(business: any) {
    this.businessData = business;
  }

  mounted() {
    setTimeout(() => {
      this.businessData = this.data;
    }, 100);
    eventBus.$on('reloadCoinStoreDetail', this.updateBusinessDetail);
  }

  beforeDestroy() {
    eventBus.$off('reloadCoinStoreDetail', this.updateBusinessDetail);
  }
}
